import { configureStore } from '@reduxjs/toolkit'
// Or from '@reduxjs/toolkit/query/react'
import { setupListeners }      from '@reduxjs/toolkit/query'
import { deviceEnrollmentApi } from './api/enrollement'
import authSlice from './store/authSlice';
import errorSlice from './store/errorSlice';
import featuresSlice from './store/featuresSlice';

export const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice
    [deviceEnrollmentApi.reducerPath]: deviceEnrollmentApi.reducer,
    auth: authSlice,
    error: errorSlice,
    features: featuresSlice
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(deviceEnrollmentApi.middleware),
})

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>;
